import { cloneJson, parseJson } from './safeJson'

export function createDtoBuilder(config = {}) {
  const defaults = config.defaults ?? {}
  const transforms = config.transforms ?? {}
  const fields = config.fields ?? null

  return function buildDto(source = {}) {
    const sourceObject = source && typeof source === 'object' ? source : {}
    const dto = cloneJson(defaults, {})
    const keys = fields ?? Object.keys(sourceObject)

    keys.forEach((key) => {
      const hasSourceValue = Object.prototype.hasOwnProperty.call(sourceObject, key)
      const rawValue = hasSourceValue ? sourceObject[key] : dto[key]

      if (typeof transforms[key] === 'function') {
        dto[key] = transforms[key](rawValue, sourceObject)
        return
      }

      if (hasSourceValue) {
        dto[key] = rawValue
      }
    })

    return dto
  }
}

export function parseJsonDtoField(value, fallback = null) {
  return parseJson(value, fallback)
}
